/* eslint-disable prefer-const */
import { PAYMENT_STATUS } from "../../constants/checkout-constants";
import { fastlyUrl, imageTypes } from "./cdn-image-url";
import { makePriceLabelRound } from "./make-price-label";
import { postOrderBookingConfirmed } from "./post-order-placed-confirmed";

/**
 * sum all the values
 *
 * @param {Array} array the array of objects where each object contains key for summation
 * @param {Object} key a property from object which needs to sum
 * @returns {number} Returns the total amount of composed arguments.
 * example: array - [{amount:12},{amount:15}]
 * return 27
 */
const getSum = (array = [], {key = "amount"} = {}) => (array || []).reduce((acc, curr) => acc + curr[key], 0);

/**
 * @param {Object} carDetails
 * {
 * config: cdn url to get image
 * content: cardetails like year,make,model,path
 * }
 * @returns {Object} imageUrl and carFullName
 */
const getCarImage = ({config = {}, content = {}, imageType = imageTypes.helloARCarCardAu}) => {
    const {year, make, model, mainImage} = content;
    const hasImage = mainImage && mainImage.path;
    const imageUrl = hasImage ? fastlyUrl(config.imageHost, mainImage.path, imageType) : "";
    const carFullName = `${year || ""} ${make || ""} ${model || ""}`;

    return {imageUrl, carFullName, ...content};
};

const validateSplitPay = ({splitPayments = [], dapOrTradePrice, selectedAmount = 0, splitPaymentOpted, orderStatus, discountValue = 0}) => {
    // const {isSplitPaymentOpted } = splitAmountDetails;
    if (!splitPayments) {
        return {
            selectedSplitAmount: selectedAmount,
            totalAmountPaid: 0,
            remainingAmount: dapOrTradePrice
        };
    }
    const  succeedPay = splitPayments.filter(d => d.paymentStatus === PAYMENT_STATUS.SUCCESS);
    const  createdPay = splitPayments.filter(d => d.paymentStatus === PAYMENT_STATUS.CREATED);
    const isFirstSplitPay =  (succeedPay.length === 0 && createdPay.length === 1) || !postOrderBookingConfirmed(orderStatus);
    const isSplitPaymentOpted =  splitPaymentOpted;
    const totalAmountPaid = getSum(succeedPay) + discountValue;
    const selectedSplitAmount = (createdPay[0] && createdPay[0].amount) || 0;
    const isFullPaymentDone =  splitPaymentOpted ? Math.round(totalAmountPaid) === Math.round(dapOrTradePrice) : true;

    return {
        isFirstSplitPay,
        isSplitPaymentOpted,
        totalAmountPaid,
        selectedSplitAmount,
        isFullPaymentDone,
        remainingAmount: Math.round(dapOrTradePrice) - totalAmountPaid - selectedSplitAmount,
        finalRemainingAmount: Math.round(dapOrTradePrice - totalAmountPaid),
        splitPayLabel: (succeedPay.length > 0 && `Payment ${succeedPay.length}`) || (isFirstSplitPay && "Deposit")
    };
};

const getAmountWithSurcharge = (amount = 0) => ({
    amountWithSurcharge: Math.round(amount),
    surcharge: 0,
    amountWithSurchargeLabel: makePriceLabelRound(Math.round(amount))
});

const getAmountWithSurchargeNew = getAmountWithSurcharge;

export {getSum, getCarImage, validateSplitPay, getAmountWithSurcharge, getAmountWithSurchargeNew};
